import { setInternalLinkingGcData } from '@web-platform/shared-banana-utils-frontend/src/singletons/seoComponents/internalLinkingGcData';
import { setInternationalSites } from '@web-platform/shared-banana-utils-frontend/src/singletons/seoComponents/internationalSites';
import { setGcCultureSelectorData } from '@web-platform/shared-universal-utils-frontend/src/singletons/cultureSelectorData';
import { setFooterData } from '@web-platform/shared-universal-utils-frontend/src/singletons/footerData';
import { setHeaderData } from '@web-platform/shared-universal-utils-frontend/src/singletons/globalHeaderData';
import {
  setCldr,
  setCulture,
  setFullDomainName,
} from '@web-platform/shared-universal-utils-frontend-localisation';
import { GLOBAL } from 'saddlebag-browser';

import type { WindowData } from '@web-platform/shared-universal-types/src/context';

type LocalisationData = Pick<WindowData, 'cldr' | 'culture' | 'fullDomainName'>;

type GlobalSingletonData = Pick<
  WindowData,
  'footerComponentData' | 'gcCultureSelectorData' | 'headerComponentData' | 'seoComponents'
>;

export const initialiseGlobalSingletons = () => {
  const windowData = GLOBAL.getWindow().__internal;

  initialiseLocalisation(windowData);
  initialiseComponentData(windowData);
};

const initialiseLocalisation = ({ cldr, culture, fullDomainName }: LocalisationData) => {
  if (cldr) setCldr(cldr);
  if (culture) setCulture(culture);
  if (fullDomainName) setFullDomainName(fullDomainName);
};

const initialiseComponentData = ({
  footerComponentData,
  gcCultureSelectorData,
  headerComponentData,
  seoComponents,
}: GlobalSingletonData) => {
  setFooterData(footerComponentData);
  setHeaderData(headerComponentData);

  setGcCultureSelectorData(gcCultureSelectorData);
  setInternationalSites(seoComponents.internationalSites);

  if (seoComponents.internalLinkingGc) {
    setInternalLinkingGcData(seoComponents.internalLinkingGc);
  }
};
